<template>

  <div>
    <div class="field-worker-earnings-component" data-app>
      <v-card elevation="2" outlined class="mx-auto">
        <v-card-title>
            <span class="select-services-dropdown-title">
              {{ labelWorkersName }} earnings
          </span>
        </v-card-title>
          <div class="ibox-content" style="padding: 0px 16px 16px;">
            <v-card-text>
          <v-expansion-panels focusable>
            <v-expansion-panel
                v-for="(contractor,i) in contractors_view"
                :key="i"
                elevation-0
            >
              <v-expansion-panel-header :id="`vue_fieldworkerShare_header_${contractor.contractor_id}`" v-if="contractor.contractor_id">
                <v-row align="center" class="spacer" no-gutters>

                  <v-col cols="1">
                    <v-avatar>
                      <img
                          :src="contractor.contractorInfo.avatar" alt=""
                      >
                    </v-avatar>
                  </v-col>

                  <v-col class="gray-text bold-font align-self-center name-alignment" md="6">
                    {{ contractor.contractorName }}
                  </v-col>


                  <v-col cols="5">
                    <v-row>
                      <v-col class="paid-amount" cols="9">
                        <div class="gray-text m-top-6 laptop-position">
                          <strong>{{ currency.currency_symbol }}{{  setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare)    }}</strong>
                        </div>

                          <div class="gray-text padding-top-10" v-if="
                          contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare != contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor
                          &&  ( contractor.payment_status == 'paid' || contractor.payment_status == 'partial paid')
                        ">
                            {{ currency.currency_symbol }}{{  setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor) }} <strong>{{ contractor.payment_status }}</strong>
                        </div>

                          <div class="gray-text padding-top-10" v-else >
                              <strong>{{ contractor.payment_status }}</strong>
                          </div>

                      </v-col>
                      <v-col class="align-self-center laptop-three-dots-display" cols="3">
                        <div class="">
                          <v-menu
                              bottom
                              left
                              :nudge-left="isModal?'550px':'10px'"
                              nudge-bottom="20px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  dark
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                              >
                              <i class="fa fa-ellipsis-v ellipsis-v" style="color: #2E4051;font-size: 18px;"></i>
                              </v-btn>
                            </template>

                            <v-list class="dropdown-menu"
                                    v-if="(!(loggedRoleFieldworker && (loggedUser != contractor.contractor_id)))">
                              <v-list-item
                                  v-for="(item, index) in unPaidListItems"
                                  :key="'A'+ index"
                                  v-if="!contractor.bookingContractorPayment.contractor_invoice_num"
                              >
                                <v-list-item-title>

                                  <a class="gray-text text-block"
                                     @click="addContractorInvoiceNumber(item.flag, bookingId, contractor.contractorInfo, contractor.contractor_id, contractor.bookingContractorPayment.payment_to_contractor_id, contractor.contractorInfo.gst, contractor.cash_amount.cash_amount , contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor)">
                                    <span class="icon-padding"><i :class=item.icon></i></span>
                                    <span> {{ item.title }} </span>
                                  </a>

                                </v-list-item-title>
                              </v-list-item>


                                <v-list-item
                                    v-if="
                                  (
                                      contractor.bookingContractorPayment.contractor_invoice_num
                                   &&
                                        (
                                            contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare > contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor

                                        )
                                  )"
                                >
                                    <v-list-item-title>




                                        <a class="gray-text text-block"
                                           @click="addContractorInvoiceNumber(1, bookingId, contractor.contractorInfo, contractor.contractor_id, contractor.bookingContractorPayment.payment_to_contractor_id, contractor.contractorInfo.gst, contractor.cash_amount.cash_amount , contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor)">
                                            <span class="icon-padding"><i :class=unPaidListItems[1].icon></i></span>
                                            <span> {{ unPaidListItems[1].title }} </span>
                                        </a>

                                    </v-list-item-title>
                                </v-list-item>
<!--                                <v-list-item v-if="canAcceptAdminServices">-->
<!--                                    <v-list-item-title>-->
<!--                                      <a class="gray-text text-block" href="#" data-toggle="modal" data-target="#popupi"-->
<!--                                         @click="showpushPopup">-->
<!--                                        <span class="icon-padding"></span>-->
<!--                                        <span> Push to Technician Calender </span>-->
<!--                                      </a>-->
<!--                                    </v-list-item-title>-->
<!--                                </v-list-item>-->

                              <v-divider class="mx-4"
                                         v-if="(
                                             !contractor.bookingContractorPayment.contractor_invoice_num
                                             ||
                                        (
                                            contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare > contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor

                                        )
                                             )"></v-divider>

                              <v-list-item
                                  v-for="(item, index1) in paidListItems" v-if="setContractorShareCheckCredential"
                                  :key="index1"
                              >
                                <v-list-item-title>
                                  <a class="gray-text text-block"
                                     @click="setFieldworkerShare(item.perService, contractor.contractor_id)">
                                    <span class="icon-padding"><i :class=item.icon></i></span>
                                    <span> {{ item.title }}</span>
                                  </a>

                                </v-list-item-title>
                              </v-list-item>

                                    <v-list-item v-show="showPaymentWithholdAction" >
                                        <v-list-item-title>
                                            <a class="gray-text text-block" @click="withholdOrReleasePayment">
                                                <span class="icon-padding"><i :class="withHoldPayment.faClass" ></i></span>
                                                <span> {{ withHoldPayment.paymentText}} </span>
                                            </a>
                                        </v-list-item-title>
                                    </v-list-item>


                            </v-list>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                </v-row>

                <template v-slot:actions>
                  <v-row>
                    <v-icon color="teal">
<!--                        <span style="color: rgb(46, 64, 81);font-size: 18px;">-->
                             mdi-chevron-down
<!--                        </span>-->

                    </v-icon>
                  </v-row>
                </template>

              </v-expansion-panel-header>

              <v-expansion-panel-content :id="`vue_fieldworkerShare_inputs_${contractor.contractor_id}`">
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong class="gray-text font-size-strong">
                          {{ labelWorkersName }} name
                        </strong>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="overflow: unset">
                      <span class="gray-text span-font-size dropdown"
                            @mouseover="handleMouseHover"
                            @mouseleave="handleMouseLeave">
                         <a style="text-decoration: none; color: #2E4051" class="dropdown-toggle"
                            data-toggle="dropdown" aria-haspopup="true">
                           {{ contractor.contractorName }}
                           <span class="caret"></span>
                          </a>
                          <div class="dropdown-menu mobile-view-transform" v-show="isDropdownVisible">
                              <contractor-info :id="contractor.contractor_id" :item-type="itemType" :item-id="itemId"></contractor-info>
                          </div>
                      </span>
                    </v-list-item-content>
                  </v-list-item>

                    <div class="hidden service_products">
                        <input
                            v-for=" ( product, index)  in contractor.contractor_share.products" :key="index"
                            :service_id = "`${product.service_id}`"
                            :markup = "`${product.markup}`"
                            :supplied-by = "`${product.supplied_by}`"
                            :markup-type = "`${product.markup_type}`"
                            :sub-total = "`${product.sub_total}`"
                            :cost = "`${product.cost}`"
                            :sale-price = "`${product.sale_price}`"
                            :ltr = "`${product.ltr}`"
                            :id="`vue_product_info_${product.service_id}_${product.clone}_product_${product.product_id}`" >
                    </div>
                    <!--                  Service and product section -->


                  <div  v-for="(contractorServices,index) in contractor.contractor_share[Object.keys(contractor.contractor_share)[0]]"
                        :key="index">
                    <div v-if="typeof contractorServices ==  'object' " class="contractor_services" :service-id="contractorServices.service_id" :service-clone="contractorServices.clone" >
                      <!--                  service name -->
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong class="gray-text font-size-strong">
                              Service name
                            </strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                        <span class="gray-text span-font-size">
                          {{contractorServices.service_name}}
                        </span>
                        </v-list-item-content>
                      </v-list-item>
                      <!--                  Product share -->
                      <v-list-item style="margin-left: 15px;">
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong class="gray-text font-size-strong">
                              Products share
                            </strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                           <span class="text-blue" v-if="setContractorShareCheckCredential"
                                @click='showInputToEdit(`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                               :id="`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_view`"> {{ currency.currency_symbol }}{{ setNumericValue(contractorServices.saved_product_share) }}
                           </span>

                           <span  v-else="setContractorShareCheckCredential" >
                               {{ currency.currency_symbol }}{{ setNumericValue(contractorServices.saved_product_share) }}
                           </span>


                            <span class="icons-position" v-if="setContractorShareCheckCredential">
                                <a :id="`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_edit_btn`"
                                   @click='showInputToEdit(`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                            style="position: absolute">
                                <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                </svg>
                              </a>
                            </span>
                            <div v-if="setContractorShareCheckCredential" :id="`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_input`" class="hidden">
                                <input type="text" class="text-input"
                                       @focus='hideOtherInputs(`${contractor.contractor_id}` , setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , "product_share" ))'
                                       :product-share="`${contractorServices.service_id}`+'_' + setIdWithClone(`${contractorServices.service_id}`, `${contractorServices.clone}`)"
                                       :value="setNumericValue(contractorServices.saved_product_share)" @keyup="writeNumericValueOnly(setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'product_share' ))"
                                       :id="setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'product_share' )"
                                >
                                <button class="btn  save-btn " @click="changeFieldworkerProductShare(`${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 0 )" > <i class="fa fa-check"></i> </button>
                                <button @click='hideInputToEdit(`vue_product_share_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                            </div>
                        </span>


                        </v-list-item-content>
                      </v-list-item>
                      <!--                  service share -->
                      <v-list-item  style="margin-left: 15px;">
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong class="gray-text font-size-strong">
                              Service share
                            </strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                          <span class="gray-text span-font-size">
                            <span class="text-blue" v-if="setContractorShareCheckCredential"
                              @click='showInputToEdit(`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                              :id="`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_view`"> {{ currency.currency_symbol }}{{ setNumericValue(contractorServices.saved_service_share) }}
                            </span>
                              <span  v-else="setContractorShareCheckCredential" > {{ currency.currency_symbol }}{{ setNumericValue(contractorServices.saved_service_share) }}
                            </span>

                            <span class="icons-position " v-if="setContractorShareCheckCredential">
                                <a :id="`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_edit_btn`"
                                   @click='showInputToEdit(`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                                >
                                <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                </svg>
                              </a>
                            </span>
                            <div v-if="setContractorShareCheckCredential" :id="`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_input`" class="hidden">
                                <input type="text" class="text-input"
                                       :service-share="`${contractorServices.service_id}`+'_' + setIdWithClone(`${contractorServices.service_id}`, `${contractorServices.clone}`)"
                                       @focus="hideOtherInputs(`${contractor.contractor_id}` , setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'separate_contractor_share_service' ))"
                                       :id="setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'separate_contractor_share_service' )"
                                       :value="setNumericValue(contractorServices.saved_service_share)"  >
                                <button class="btn  save-btn "
                                        @click="changeFieldworkerProductShare(`${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 1 )"
                                > <i class="fa fa-check"></i> </button>
                                <button
                                    @click='hideInputToEdit(`vue_separate_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                            </div>
                          </span>
                        </v-list-item-content>
                      </v-list-item>
<!-- service total share -->
                    <v-list-item  style="margin-left: 15px;">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    Service total share
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                      <span class="gray-text span-font-size">
                        <span class="text-blue" v-if="setContractorShareCheckCredential"
                            @click='showInputToEdit(`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                            :id="`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_view`">
                            {{ currency.currency_symbol }}{{ setNumericValue(contractorServices.saved_total_service_share) }}
                        </span>

                          <span v-else="setContractorShareCheckCredential" >
                              {{ currency.currency_symbol }} {{ setNumericValue(contractorServices.saved_total_service_share) }}
                        </span>
                        <span class="icons-position" v-if="setContractorShareCheckCredential">
                            <a :id="`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_edit_btn`"
                               @click='showInputToEdit(`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                               style="position: absolute">
                            <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                            </svg>
                          </a>
                        </span>
                        <div v-if="setContractorShareCheckCredential" :id="`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_input`" class="hidden">
                            <input type="text" class="text-input" :service-id="`${contractorServices.service_id}`" :clone="`${contractorServices.clone}`" :vue-contractor-service-share="`${contractor.contractor_id}`"
                                   @focus="hideOtherInputs(`${contractor.contractor_id}` , setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'contractor_share_service' ))"
                                   :id="setInputId(  `${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` , 'contractor_share_service' )"
                                   :value="contractorServices.saved_total_service_share"  >
                            <button class="btn  save-btn "
                                @click="changeContractorTotalServiceShare(`${contractorServices.service_id}`, `${contractorServices.clone}`,`${contractor.contractor_id}` )"
                            > <i class="fa fa-check"></i> </button>
                            <button @click='hideInputToEdit(`vue_contractor_share_service_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                        </div>
                      </span>
                        </v-list-item-content>
                    </v-list-item>

                        <v-list-item  style="margin-left: 15px;">
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong class="gray-text font-size-strong">
                              Service payrate type
                            </strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                          <span class="gray-text span-font-size">
                            {{ contractorServices.pay_rate_type }}
                          </span>
                        </v-list-item-content>
                      </v-list-item>

<!--                        pay rate select-->
                        <v-list-item  style="margin-left: 15px;">
                            <v-list-item-content>
                              <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                  Service payrate
                                    <a href="javascript:;" v-if="!contractorServices.pay_rate.length" onClick="popupi_helper_text()"> <i
                                        class="fa fa-info-circle fa-lg"></i></a>
                                </strong>

                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content>
                              <span class="gray-text span-font-size">
                                <span v-if="contractorServices.pay_rate.length">
                                    <span class="text-blue" v-if="setContractorShareCheckCredential"
                                          @click='showInputToEdit(`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                                          :id="`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_view`"> {{ contractorServices.pay_rate_value }}{{ contractorServices.pay_rate_sign }}
                                    </span>

                                    <span v-else="setContractorShareCheckCredential" > {{ contractorServices.pay_rate_value }}{{ contractorServices.pay_rate_sign }}</span>

                                </span>
                                  <span v-else="!contractorServices.pay_rate.length">
                                      0.00%
                                  </span>


                                <span class="icons-position" v-if="setContractorShareCheckCredential && contractorServices.pay_rate.length">
                                    <a :id="`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_edit_btn`"
                                       @click='showInputToEdit(`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)'
                                       style="position: absolute">
                                    <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                    </svg>
                                  </a>
                                </span>
                                <div v-if="setContractorShareCheckCredential" :id="`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}_input`" class="hidden">
                                    <select style="width: 150px;"
                                            :id="`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}`"
                                            @change='hideOtherInputs(`${contractor.contractor_id}`,`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` )'
                                            name="`service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}`"
                                            class=""
                                            >
                                            <option :selected="contractorServices.pay_rate_id == key"
                                                v-for="(pay_rate,key) in contractorServices.pay_rate"
                                                :key="key"
                                                elevation-0

                                                :payrate-structure="`${contractorServices.payrate_structure}`"
                                                :hours="`${contractorServices.hours}`"
                                                :payrate-type="`${pay_rate.type}`"
                                                :service-qoute="`${contractorServices.service_qoute}`"
                                                :product-qoute="`${contractorServices.product_qoute}`"
                                                :payrate-value="`${pay_rate.value}`"
                                                :contractor-id="`${contractorServices.contractor_id}`"
                                                :service-id="`${contractorServices.service_id}`"
                                                :value="`${key}`"

                                                >
                                                    {{ getPayRateOption(pay_rate)}}
                                            </option>
                                    </select>
                                    <button class="btn  save-btn "
                                            @click="change_service_payrate(`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`,`${contractorServices.clone}`,`${contractorServices.contractor_id}`)"
                                    > <i class="fa fa-check"></i> </button>
                                    <button @click='hideInputToEdit(`vue_service_pay_rate_id_${contractorServices.service_id}_${contractorServices.clone}_${contractorServices.contractor_id}` , `${contractorServices.service_id}`, `${contractorServices.clone}`, `${contractorServices.contractor_id}`)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                                </div>


                              </span>
                            </v-list-item-content>
                          </v-list-item>

<!--                        <v-list-item style="margin-left: 15px;" v-if="contractorServices.have_gst == 1">-->
<!--                            <v-list-item-content>-->
<!--                              <v-list-item-title>-->
<!--                                <strong class="gray-text font-size-strong">-->
<!--                                  Service GST-->
<!--                                </strong>-->
<!--                              </v-list-item-title>-->
<!--                            </v-list-item-content>-->
<!--                            <v-list-item-content>-->
<!--                          <span class="gray-text span-font-size">-->
<!--                            {{ currency.currency_symbol }}{{ contractorServices.gst_amount }}-->
<!--                          </span>-->
<!--                            </v-list-item-content>-->
<!--                        </v-list-item>-->

                    </div>
                  </div>


<!--                    <v-list-item >-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title>-->
<!--                                <strong class="gray-text font-size-strong">-->
<!--                                    {{ labelWorkersName }} share-->
<!--                                    <a href="javascript:;" onClick="popupi_helper_text()"> <i-->
<!--                                        class="fa fa-info-circle fa-lg"></i></a>-->
<!--                                </strong>-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->

<!--                        <v-list-item-content>-->
<!--                        <span class="gray-text span-font-size" >-->
<!--                            {{ currency.currency_symbol }}{{ contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare}}-->
<!--                        </span>-->
<!--                        </v-list-item-content>-->
<!--                    </v-list-item>-->

                    <v-list-item v-if="contractor.contractor_share.have_gst == 0">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    {{ labelWorkersName }} share
                                    <a href="javascript:;" onClick="popupi_helper_text()"> <i
                                        class="fa fa-info-circle fa-lg"></i></a>
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                           <span class="text-blue" v-if="setContractorShareCheckCredential"
                               @click='showInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}` , 0, 0, `${contractor.contractor_id}`, 1)'
                               :id="`vue_total_contractor_shares_${contractor.contractor_id}_view`"> {{ currency.currency_symbol }}{{ setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare) }}
                           </span>

                             <span class="icons-position" v-if="setContractorShareCheckCredential">
                                 <a :id="`vue_total_contractor_shares_${contractor.contractor_id}_edit_btn`"
                                    @click='showInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}` , 0, 0, `${contractor.contractor_id}`, 1)'
                                    style="position: absolute">
                                    <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                    </svg>
                                  </a>
                             </span>

                            <span v-else="setContractorShareCheckCredential" > {{ currency.currency_symbol }}{{ setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare) }}
                           </span>
                            <div :id="`vue_total_contractor_shares_${contractor.contractor_id}_input`" class="hidden" v-if="setContractorShareCheckCredential">
                                <input type="text" class="text-input"
                                       @focus="hideOtherInputs(`${contractor.contractor_id}` ,`vue_total_contractor_shares_${contractor.contractor_id}` )"
                                       :id="`vue_total_contractor_shares_${contractor.contractor_id}`"
                                       :prev-value="setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare)"
                                       :value="setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare)" >
                                <button class="btn  save-btn "
                                    @click="changeTotalContractorShare(`${contractor.contractor_id}` )"
                                > <i class="fa fa-check"></i> </button>
                                <button @click='hideInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}`, 0, 0, `${contractor.contractor_id}`, 1)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                            </div>
                        </span>
                        </v-list-item-content>
                    </v-list-item>


                    <v-list-item >
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    Registered for tax (registered for {{labelGSTName}})
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content>
                            <span class="gray-text span-font-size" v-if="contractor.contractor_share.have_gst == 0">
                                No
                            </span>
                            <span class="gray-text span-font-size" v-if="contractor.contractor_share.have_gst">
                                Yes
                            </span>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="contractor.contractor_share.have_gst == 0">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    GST
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                            {{ currency.currency_symbol }}0
                        </span>
                        </v-list-item-content>
                    </v-list-item>





<!--                    Technician share -->
                    <v-list-item v-if="contractor.contractor_share.have_gst">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    {{ labelWorkersName }} share
                                    <a href="javascript:;" onClick="popupi_helper_text()"> <i
                                        class="fa fa-info-circle fa-lg"></i></a>
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                            {{ currency.currency_symbol }}{{ contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].total_without_gst  }}
                        </span>
                        </v-list-item-content>
                    </v-list-item>


                    <v-list-item v-if="contractor.contractor_share.have_gst">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    Tax on share amount
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                            {{ currency.currency_symbol }}{{ contractor.contractor_share.total_gst }}
                        </span>
                        </v-list-item-content>
                    </v-list-item>

<!--                   share excluding tax -->
                    <v-list-item v-if="contractor.contractor_share.have_gst">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    {{ labelWorkersName }} share including tax
                                    <a href="javascript:;" onClick="popupi_helper_text()"> <i
                                        class="fa fa-info-circle fa-lg"></i></a>
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                            <span class="gray-text span-font-size" >
                                <span class="text-blue" v-if="setContractorShareCheckCredential"
                                    @click='showInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}` , 0, 0, `${contractor.contractor_id}`, 1)'
                                    :id="`vue_total_contractor_shares_${contractor.contractor_id}_view`"> {{ currency.currency_symbol }}{{ setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare ) }}
                                </span>




                                <span v-else="setContractorShareCheckCredential" > {{ currency.currency_symbol }}{{ setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare ) }}
                                </span>


                                 <span class="icons-position" v-if="setContractorShareCheckCredential">
                                     <a :id="`vue_total_contractor_shares_${contractor.contractor_id}_edit_btn`"
                                        @click='showInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}` , 0, 0, `${contractor.contractor_id}`, 1)'
                                        style="position: absolute">
                                        <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                        </svg>
                                      </a>
                                 </span>
                                <div   v-if="setContractorShareCheckCredential" :id="`vue_total_contractor_shares_${contractor.contractor_id}_input`" class="hidden">
                                    <input type="text" class="text-input"
                                           @focus="hideOtherInputs(`${contractor.contractor_id}` ,`vue_total_contractor_shares_${contractor.contractor_id}` )"
                                           :id="`vue_total_contractor_shares_${contractor.contractor_id}`"
                                           :prev-value="setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare)"
                                           :value="setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].savedTotalShare )"  >
                                    <button class="btn  save-btn " @click="changeTotalContractorShare(`${contractor.contractor_id}` )" > <i class="fa fa-check"></i> </button>
                                    <button @click='hideInputToEdit(`vue_total_contractor_shares_${contractor.contractor_id}`, 0, 0, `${contractor.contractor_id}`, 1)' class="btn  cancel-btn"  > <i class="fa fa-remove"></i> </button>
                                </div>

                            </span>
                        </v-list-item-content>
                    </v-list-item>



                    <v-list-item  v-if="contractor.payment_status == 'paid' || contractor.payment_status == 'partial paid'">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    {{ labelWorkersName }} paid amount

                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                        <span class="gray-text span-font-size" >
                            {{ currency.currency_symbol }}{{ setNumericValue(contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor ) }}
                        </span>
                        </v-list-item-content>
                    </v-list-item>

<!--                  payment status -->
                  <v-list-item v-if="!isWithHoldPayment">
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong class="gray-text font-size-strong">
                          Payment status
                        </strong>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                      <span class="gray-text span-font-size">
                        {{ contractor.payment_status.toUpperCase() }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>


                    <v-list-item v-if="isWithHoldPayment">
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong class="gray-text font-size-strong">
                                    Payment status
                                </strong>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content>
                            <div>
                                <span  style="border-radius: 50px; max-width: 100%;/* margin:4px; */ border:1px solid transparent;border-radius: 50px;background: red;padding: 6px 12px;font-weight: 400;line-height: 1.42857143;font-size: 12px;color: white;">
                                    Payment withheld
                              </span>

                            </div>
                        </v-list-item-content>
                    </v-list-item>

<!--                  fieldworker invoice -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong class="gray-text font-size-strong">
                          {{labelWorkersName}} invoice number
                        </strong>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content v-if="contractor.ContractorPaymentInvoices.length > 0">
<!--                    <v-list-item-content v-if="contractor.bookingContractorPayment.contractor_invoice_num">-->
                      <span class="gray-text span-font-size">
                        <div v-for="(contractorPayment,cpIndex) in contractor.ContractorPaymentInvoices">

                              <span><a @click="getInvoiceNumberUrl(contractorPayment.contractor_id,contractorPayment.contractor_invoice_num)">
                                {{
                                      contractorPayment.contractor_invoice_num ? contractorPayment.contractor_invoice_num : '-'
                                }}
                              </a></span>
                              <span class="icons-position"><a v-if="ModifyFieldworkerInvoiceNumberCheckCredential"
                                 @click="addContractorInvoiceNumber(2, bookingId, contractor.contractorInfo, contractorPayment.contractor_id, contractorPayment.payment_to_contractor_id, contractor.contractorInfo.gst, contractor.cash_amount.cash_amount , contractor.contractor_share[Object.keys(contractor.contractor_share)[0]].payment_to_contractor)"
                                                              style="">
                                <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"/>
                                </svg>
                              </a></span>
                              <span class="icons-position"><a v-if="contractorPayment.contractor_invoice_num && DeleteFieldworkerInvoicePaymentStatusCheckCredential"
                                 @click="deletePayment(contractorPayment.id)"
                                                              style="">
                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#2E4051"/>
                                </svg>
                              </a></span>
                        </div>
                      </span>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <span class="gray-text span-font-size">
                        ---
                      </span>
                    </v-list-item-content>
                  </v-list-item>

                </v-list>
              </v-expansion-panel-content>


            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
          </div>
      </v-card>
    </div>
    <confirmation-popup
        title="Copy fieldworker share"
        message="Would you like to copy the fieldworker share to all recurring bookings"
        id="apply-recurring-dialogId" confirm-btn-text="Yes" cancel-btn-text="No" @on-confirm="saveFieldworkerShare(shareContractorId,true)" @on-cancel="saveFieldworkerShare(shareContractorId,false)"></confirmation-popup>

<!--    <div class="business-earnings-component margin-top-10">-->
<!--      <v-card elevation="2" outlined class="mx-auto">-->
<!--        <v-card-title>-->
<!--          <v-row>-->
<!--            <v-col><strong class="gray-text"> Business earnings </strong></v-col>-->
<!--            <v-col class="text-align-end"><strong class="gray-text"> {{ currency.currency_symbol }}{{ business_earnings }} </strong></v-col>-->
<!--          </v-row>-->
<!--        </v-card-title>-->
<!--      </v-card>-->
<!--    </div>-->
  </div>


</template>


<script>
import ContractorInfo from "@/modules/common/components/ContractorInfo.vue";

let humanRead = (num,intSep = ',',floatSep = '.') => {

    return new Intl
        .NumberFormat('en-US')
        .format(num)
        .replaceAll('.',floatSep)
        .replaceAll(',',intSep);

}
import 'vuetify';
import {getFieldworkersEarnings} from "@/modules/Invoice/api/filedworkerearnings";
import {paymentFieldworker} from "@/modules/Invoice/api/filedworkerearnings";
import {unPaidFieldworker} from "@/modules/Invoice/api/filedworkerearnings";
import {saveFieldworkerShareInfo} from "../../api/filedworkerearnings";
import {EventBus} from "@/events/event-bus";
import axios from "axios";

export default {
  name: "FieldworkerEarnings",
    components: {ContractorInfo},
  props: {
    bookingId: {},
    itemType: {},
    itemId: {},
      isModal:false,
    mergedInvoiceId: {},
    bookingNums: {},
    viewLocation: {
        default:'booking'
    },
    hasRecurring: {}
  },
  data: () => ({
    unPaidListItems: [
      {
        title: 'Assign invoice',
        icon: 'fa fa-file',
        url: '',
        flag: 0,
      },
      {
        title: 'Save as paid',
        icon: 'fa fa-files-o',
        url: '',
        flag: 1,
      },
    ],
    paidListItems: [
      {
        title: 'Set fieldworker share',
        icon: 'fa fa-money',
        url: '',
        perService: 0,
      },
      {
        title: 'Set fieldworker share per service',
        icon: 'fa fa-credit-card',
        url: '',
        perService: 1,
      },
    ],
    withHoldPayment:{},
      withHoldPayment_hide: '',
    loggedUser: '',
    contractors_view: {},
    currency: {},
    labelWorkersName: '',
    labelGSTName: '',
    invoiceNumberURL: '',
    reportContractorsBookingsSummary: '/reports/contractors_bookings_summary',
    editPopUpLabel: '',
    contractorShareByID: '',
    business_earnings: '',
    isWithHoldPayment: 0,
    showPaymentWithholdAction: 0,

    contractorShare: 0,
    calculated_contractor_share: 0,
    cash_amount: 0,
    registered_gst: 0,

    loggedRoleNotAdmin: false,
    loggedRoleFieldworker: false,
    ModifyFieldworkerInvoiceNumberCheckCredential: false,
    canAcceptAdminServices: false,
    DeleteFieldworkerInvoicePaymentStatusCheckCredential: false,
    setContractorShareCheckCredential: false,
    contractorsBookingSummaryWithSaveAsPaidCheckCredential: false,
    isDropdownVisible: false,
    dropDownClicked:0,
    shareContractorId: 0
  }),

  created() {
    getFieldworkersEarnings(this.bookingId, this.itemType, this.itemId, this.mergedInvoiceId, this.bookingNums, this.viewLocation)
        .then((response) => {

          this.loggedUser = response.data.loggedUser;
          this.loggedRoleNotAdmin = response.data.loggedRoleNotAdmin;
          this.loggedRoleFieldworker = response.data.loggedRoleFieldworker;

          this.labelWorkersName = response.data.labelWorkersName;
          this.labelGSTName = response.data.gstName;
          this.contractors_view = response.data.contractors_view;
          this.business_earnings = response.data.business_earnings;
          this.currency = response.data.currency;
          this.ModifyFieldworkerInvoiceNumberCheckCredential = response.data.ModifyFieldworkerInvoiceNumberCheckCredential;
          this.canAcceptAdminServices = response.data.canAcceptAdminServices;
          this.DeleteFieldworkerInvoicePaymentStatusCheckCredential = response.data.DeleteFieldworkerInvoicePaymentStatusCheckCredential;
          this.setContractorShareCheckCredential = response.data.setContractorShareCheckCredential;
          this.contractorsBookingSummaryWithSaveAsPaidCheckCredential = response.data.contractorsBookingSummaryWithSaveAsPaidCheckCredential;

            this.withHoldPayment = response.data.withHoldPayment;
            this.isWithHoldPayment = response.data.isWithHoldPayment;
            this.showPaymentWithholdAction = response.data.showPaymentWithholdAction;
            this.withHoldPayment_hide = (this.withHoldPayment ) ? '' : 'hidden' ;
            this.editPopUpLabel = 'Edit ' + this.labelWorkersName + ' Invoice';

            this.paidListItems = [
                {
                    title: `Set ${this.labelWorkersName} share`,
                    icon: 'fa fa-money',
                    url: '',
                    perService: 0,
                },
                {
                    title: `Set ${this.labelWorkersName} share per service`,
                    icon: 'fa fa-credit-card',
                    url: '',
                    perService: 1,
                },
            ]

        })
  },
  mounted() {
    EventBus.$on('getFieldworkersEarningsData', () => {
      this.getFieldworkersEarningsData()
    });
  },
  methods: {
    showpushPopup(){
      window.popupi('Push to Google Calendar', `/dashboard/resendAdminServices/${this.bookingId}`);
    },
    writeNumericValueOnly(el){
        $("#"+el).val($("#"+el).val().replace(/[^0-9\.]/, ''));
    },
    getPayRateOption(pay_rate){
        let text = '';
      if(pay_rate.type != "percent"){
          text += this.currency.currency_symbol;
      }
      text += " " + pay_rate.value;
        if(pay_rate.type == "percent"){
            text += " " + this.capitalizeFirstLetter(pay_rate.field_name);
        }
        return text;
    },
    checkSelected(key, service){
        if(key == service.pay_rate_id){
            return true;
        }
        return false;
    },
    showInputToEdit(elName , serviceId , clone, productId, isMainElement = 0){
        if(isMainElement){
            document.getElementById(elName+'_view').setAttribute("class","hidden")
            document.getElementById(elName+'_input').removeAttribute("class","hidden")
            document.getElementById(elName+'_edit_btn').setAttribute("class","hidden")

        }else{
            document.getElementById(elName+'_view').setAttribute("class","hidden")
            document.getElementById(elName+'_input').removeAttribute("class","hidden")
            document.getElementById(elName+'_edit_btn').setAttribute("class","hidden")

        }
    },
      hideOtherInputs(fieldWorkerId , id){
          let el = $("#vue_fieldworkerShare_inputs_"+fieldWorkerId+" .cancel-btn" );
          el.each(function () {
              if( $(this).prev().prev().attr("id") != id ) {
                  $(this).trigger('click');
              }
          })

      },
    capitalizeFirstLetter(str) {
      // converting first letter to uppercase
      const capitalized = str.replace(/^./, str[0].toUpperCase());
      return capitalized.replace(/([A-Z])/g, ' $1').trim();
    },
    hideInputToEdit(elName , serviceId , clone, productId){
        document.getElementById(elName+'_input').setAttribute("class","hidden")
        // document.getElementById(elName+'_view').removeAttribute("class","hidden")
        document.getElementById(elName+'_view').setAttribute("class"," text-blue")
        document.getElementById(elName+'_edit_btn').removeAttribute("class","hidden")
    },
    saveFieldworkerShare(fieldworkerId,update_repeated=false){
        let inputs = $("#vue_fieldworkerShare_inputs_" + fieldworkerId  + " input")
        let select = $("#vue_fieldworkerShare_inputs_" + fieldworkerId  + " select")
        let formDataInputs = new FormData();
        inputs.each(function(){
            formDataInputs.append($(this).attr('id').replace("vue_" , '') , $(this).val());
            console.log("ID : " + $(this).attr('id') + " with Value : "  + $(this).val());
            formDataInputs.append('contractor_shares['+fieldworkerId+']' , $(this).val());

        })

        select.each(function(){
            formDataInputs.append($(this).attr('id').replace("vue_" , '').replace("_0_" , '_') , $(this).val());
            console.log("select ID : " + $(this).attr('id').replace("_0_" , '_') + " with Value : "  + $(this).val());
        })
        formDataInputs.append("update_repeated",update_repeated)
        saveFieldworkerShareInfo(formDataInputs , fieldworkerId,this.bookingId).then((response) => {
          this.getFieldworkersEarningsData()
        });
    },
    getFieldworkersEarningsData(){
      getFieldworkersEarnings(this.bookingId, this.itemType, this.itemId, this.mergedInvoiceId, this.bookingNums, this.viewLocation)
          .then((response) => {
            console.log(response)
            this.loggedUser = response.data.loggedUser;
            this.loggedRoleNotAdmin = response.data.loggedRoleNotAdmin;
            this.loggedRoleFieldworker = response.data.loggedRoleFieldworker;
            this.labelWorkersName = response.data.labelWorkersName;
            this.labelGSTName = response.data.gstName;
            this.contractors_view = response.data.contractors_view;
            this.business_earnings = response.data.business_earnings;
            this.currency = response.data.currency;
            this.ModifyFieldworkerInvoiceNumberCheckCredential = response.data.ModifyFieldworkerInvoiceNumberCheckCredential;
            this.setContractorShareCheckCredential = response.data.setContractorShareCheckCredential;
            this.contractorsBookingSummaryWithSaveAsPaidCheckCredential = response.data.contractorsBookingSummaryWithSaveAsPaidCheckCredential;
            this.editPopUpLabel = 'Edit ' + this.labelWorkersName + ' Invoice';
              this.withHoldPayment = response.data.withHoldPayment;
              this.isWithHoldPayment = response.data.isWithHoldPayment;
              this.showPaymentWithholdAction = response.data.showPaymentWithholdAction;
              this.withHoldPayment_hide = (this.withHoldPayment ) ? '' : 'hidden' ;
          })
    },
    setInputId(serviceId, clone, contractorId, idText){
        serviceId = (clone != 0) ? serviceId + "_" + clone : serviceId ;
        return "vue_"+idText + "_" + serviceId + "_" + contractorId;
    },
    setIdWithClone(serviceId, clone){
        return ( (clone != 0) ? serviceId + "_" + clone : serviceId );
    },
    changeFieldworkerProductShare(separatedServiceId, clone, contractorId ,type = ''){
        let serviceId = (clone != 0) ? separatedServiceId + "_" + clone : separatedServiceId ;
        let serviceShare = this.getNumericInputValue("vue_separate_contractor_share_service_" + serviceId + "_" + contractorId);
        let productShare = this.getNumericInputValue("vue_product_share_" + serviceId + "_" + contractorId);
        let sum = parseFloat(serviceShare+productShare).toFixed(2);
        // set contractor total share
        $("#vue_contractor_share_service_" + serviceId + "_" + contractorId).val(sum);
        $("#vue_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId + "_view").html(this.currency.currency_symbol + sum);

        // set service share and product share tp the text
        $("#vue_separate_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId + "_view").html(this.currency.currency_symbol + serviceShare.toFixed(2));
        $("#vue_product_share_" + separatedServiceId + "_" + clone + "_" + contractorId + "_view").html(this.currency.currency_symbol + productShare.toFixed(2));

        // hide product and service share  inputs
        if(type == 0){
            this.hideInputToEdit("vue_product_share_" + separatedServiceId + "_" + clone + "_" + contractorId )
        }

        if(type == 1){
            this.hideInputToEdit("vue_separate_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId )
        }
        // calculate the total contractor share
        this.calculateTotalContractorShare(contractorId);
    },
    changeContractorTotalServiceShare(separatedServiceId, clone, contractorId){
        let serviceId = (clone != 0) ? separatedServiceId + "_" + clone : separatedServiceId ;
        let productShare = this.getNumericInputValue("vue_product_share_" + serviceId + "_" + contractorId);
        let totalShare = this.getNumericInputValue("vue_contractor_share_service_" + serviceId + "_" + contractorId);
        let serviceShare = parseFloat(totalShare-productShare).toFixed(2);
        totalShare = parseFloat(totalShare).toFixed(2);
        //set separate contractor service share in input and the view
        $("#vue_separate_contractor_share_service_" + serviceId + "_" + contractorId).val(serviceShare);
        $("#vue_separate_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId + "_view").html(this.currency.currency_symbol + serviceShare);

        // set contractor service total share in view
        $("#vue_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId + "_view").html(this.currency.currency_symbol + totalShare);

        // hide Input
        this.hideInputToEdit("vue_contractor_share_service_" + separatedServiceId + "_" + clone + "_" + contractorId )
        // calculate the total contractor share
        this.calculateTotalContractorShare(contractorId);
    },
    changeTotalContractorShare(contractor_id = 0){
        let vm = this;
          // let prevValue = $("#vue_total_contractor_shares_" + contractor_id).attr("prev-value");
          let totalContractorShare = $("#vue_total_contractor_shares_" + contractor_id).val().replace(/[^0-9.-]+/g,"")
            totalContractorShare = parseFloat(totalContractorShare).toFixed(2);
          let Services = $('input[vue-contractor-service-share='+ contractor_id +']');
          let servicesCount = Services.length;
          let serviceShare = (totalContractorShare/servicesCount);
          let currencySymbol = this.currency.currency_symbol;
              Services.each(function (){

                  let service_id = $(this).attr('service-id');
                  let clone = $(this).attr('clone');
                  $("#vue_contractor_share_service_" + service_id + "_" + clone  + "_" + contractor_id + "_view").html(currencySymbol + serviceShare);
                  // $("#vue_contractor_share_service_" + service_id + "_" + contractor_id + "_view").html(currencySymbol + serviceShare);
                    if(clone != 0){
                        $("#vue_contractor_share_service_" + service_id + "_" + clone + "_" + contractor_id).val(serviceShare);
                    }else{
                        $("#vue_contractor_share_service_" + service_id + "_" + contractor_id).val(serviceShare);
                    }
                  // $("#vue_contractor_share_service_" + service_id + "_" + contractor_id).next().trigger("click");
                  // vm.changeContractorTotalServiceShare(service_id, clone, contractor_id)
              })


        $("#total_contractor_shares_" + contractor_id + "_view").html(currencySymbol + totalContractorShare);


        $("#vue_fieldworkerShare_inputs_"+contractor_id + " .contractor_services").each(function () {
            let service_id = $(this).attr('service-id');
            let clone = $(this).attr('service-clone');
            vm.changeContractorTotalServiceShare(service_id, clone,contractor_id);
        })

        // hide Input
        vm.hideInputToEdit("vue_total_contractor_shares_" + contractor_id )

        // this.saveFieldworkerShare(contractor_id);

    },
    calculateTotalContractorShare(contractor_id = 0){
        let contractorServicesShare = $('input[vue-contractor-service-share^=' + contractor_id + "]")
        var totalShare = 0;
        contractorServicesShare.each(function(){
            totalShare += parseFloat($(this).val().replace(/[^0-9.-]+/g,""));
        })
        totalShare = totalShare.toFixed(2);
        $("#vue_total_contractor_shares_" + contractor_id).val(totalShare)
        $("#vue_total_contractor_shares_" + contractor_id + "_view").html(totalShare)
        $("#vue_total_contractor_shares_" + contractor_id).attr("prev-value",totalShare);
        this.shareContractorId = contractor_id
      if(this.hasRecurring)
        $("#apply-recurring-dialogId").modal('show')
      else
        this.saveFieldworkerShare(contractor_id);
    },
    getNumericInputValue(id = ''){
        let inputValue = document.getElementById(id).value.replace(/[^0-9.-]+/g,"");
        let returnNumericInputValue = 0;
        if($.isNumeric(inputValue)){
            returnNumericInputValue = inputValue;
        }else{
            $(id).val(0);
        }
        return parseFloat(returnNumericInputValue);
    },
    change_service_payrate(id = '' , serviceId , clone, contractorId){

        let vm = this;
        var selected_payrate = $('#' + id + ' option:selected');
        var hours = selected_payrate.attr('hours');
        var payrate_structure = selected_payrate.attr('payrate-structure');
        var payrate_type = selected_payrate.attr('payrate-type');
        var payrate_value = selected_payrate.attr('payrate-value');
        var service_qoute = selected_payrate.attr('service-qoute').replace(/[^0-9.-]+/g,"");
        var product_qoute = selected_payrate.attr('product-qoute').replace(/[^0-9.-]+/g,"");
        // var contractorId = selected_payrate.attr('contractor-id');
        // var serviceId = selected_payrate.attr('service-id');
        var service_share = 0 ;
        var product_share = 0 ;

        var products = $("input[id^=vue_product_info_" + serviceId + "_" + clone + "_product_]")
        var serviceProductsCost = 0;
        var serviceProductsShare = 0;
        products.each(function(){

            if($(this).attr('supplied-by') == 'fieldworker'){
                serviceProductsCost += ( parseFloat($(this).attr('cost'))) * $(this).attr('ltr');
            }

            if($(this).attr('markup-type') == '%' ){
                serviceProductsShare += ( $(this).attr('sale-price') - $(this).attr('cost') )  * $(this).attr('ltr');
            }else{
                serviceProductsShare += $(this).attr('markup') * $(this).attr('ltr');
            }

        })
        // //if commission check if percent or flat
        if(payrate_structure == 'commission'){
            //if percent get service_share by commission
            if(payrate_type == 'percent'){
                service_share = (service_qoute )* (payrate_value / 100 );
                product_share = ( (serviceProductsShare * payrate_value) / 100 ) + parseFloat(serviceProductsCost);
                // product_share = (product_qoute * payrate_value) / 100;

            }
            //if flat save it in service_share directly
            else{
                service_share = payrate_value;
                product_share = serviceProductsCost;
            }
        }
        else{
            service_share = payrate_value * hours;
        }

        let fixedServiceShare = parseFloat(service_share).toFixed(2);

        product_share = parseFloat(product_share).toFixed(2);
        //set ( contractor service share  && contractor products share )for this service and clone
        $("#vue_separate_contractor_share_service_" + serviceId + "_" + clone  + "_" + contractorId + "_view").html( fixedServiceShare);
        $("#vue_product_share_" + serviceId + "_" + clone  + "_" + contractorId + "_view").html(vm.currency.currency_symbol + product_share);
        if(clone != 0){
            $("#vue_separate_contractor_share_service_" + serviceId + "_" + clone + "_" + contractorId).val(fixedServiceShare);
            $("#vue_product_share_" + serviceId + "_" + clone + "_" + contractorId).val(product_share);
        }else{
            $("#vue_separate_contractor_share_service_" + serviceId + "_" + contractorId).val(fixedServiceShare);
            $("#vue_product_share_" + serviceId + "_" + contractorId).val(product_share);
        }
        // set pay rate new value
        $("#" + id + "_view").html(selected_payrate.text());
        vm.changeFieldworkerProductShare(serviceId, clone, contractorId , 3);
        vm.hideInputToEdit(id )

    },
      withholdOrReleasePayment(){

          if(confirm(this.withHoldPayment.confirmMessage)){
              let url = this.withHoldPayment.actionURL;
              axios.get(url).then(response => {
                  if(response.data.success){
                      this.getFieldworkersEarningsData();
                      $.notify(response.data.message , 'success');

                  }
              });

              // window.location.href = this.withHoldPayment.actionURL;
          }
      },
    addTipValue(amount , tip){
      return (parseFloat(amount) + parseFloat(tip)).toFixed(2);
    },
    fieldworkerShare(bookingId, fieldworkerInfo, callback) {
      paymentFieldworker(bookingId, fieldworkerInfo)
          .then((response) => {
            callback( ( response.data.fieldworkerShare - response.data.totalPaidAmount ))
          })
    },

    getInvoiceNumberUrl(contractorId, contractorInvoiceNum) {
      let url = `?fltr[contractor_id]=${contractorId}&fltr[Inv]=${encodeURI(contractorInvoiceNum)}`;
      const testingUrl = this.reportContractorsBookingsSummary + url;

      window.open(testingUrl, '_blank');
    },

    addContractorInvoiceNumber(flag, bookingId, fieldworkerInfo, contractorId, paymentToContractorId, contractorGst, cashAmount, paidAmount) {
      let vm = this;
      this.fieldworkerShare(bookingId, fieldworkerInfo, function (data) {

        vm.contractorShareByID = data;

        if (contractorGst === 0) {
          vm.registered_gst = 0
        } else {
          vm.registered_gst = 1
        }

        let zero = 0;
        window.contractor_share = (vm.contractorShareByID).toFixed(2);
        window.cash_received = cashAmount ?? zero.toFixed(2);
        window.required_contractor_payment = Number((contractor_share )).toFixed(2);
        window.booking_payments = '';
        window.payment_to_contractor = contractor_share - cash_received;
        window.booking_payments += bookingId + '_' + contractorId + '_' + window.payment_to_contractor + '_';
        window.page_type = "vuejs";
        window.registerd_gst = cashAmount;
        window.contractor_id = contractorId;

        let base_url = `/ajax/addContractorInvoiceNumber`;
        let url = '';
        let popUpLabel = '';


        if (flag == 0 || flag == 1) {

          // Assign invoice and save as paid

          popUpLabel = flag == 0 ? 'Assign Invoice' : 'Save As Paid'

          url = `${base_url}/${flag}?registerd_gst=${vm.registered_gst}`;

          $('#popupi').modal('show');
          popupi(popUpLabel, url);

        } else if (flag == 2) {

          // Edit payment

          url = `${base_url}/${flag}?registerd_gst=${vm.registered_gst}&payment_to_contractor_id=${paymentToContractorId}`;

          $('#popupi').modal('show');
          popupi(vm.editPopUpLabel, url);

        }

      })


    },

    deletePayment(fieldworkerPaymentId) {
      let data = {
        title: "Are you sure you want to delete this payment?",
      }
      let vm = this;
      confirm_popup(data, function () {
        unPaidFieldworker(fieldworkerPaymentId)
            .then(() => {
                vm.getFieldworkersEarningsData();
              // window.location.reload();
            })
      });
    },

    setFieldworkerShare(perService, fieldWorkerId) {
        // vue_fieldworkerShare_header
        if($("#vue_fieldworkerShare_inputs_"+fieldWorkerId).length){
            let style = $("#vue_fieldworkerShare_inputs_"+fieldWorkerId).attr('style');
            if(style){
                $("#vue_fieldworkerShare_inputs_"+fieldWorkerId).prev('button').trigger('click');
            }
        }else{
            $("#vue_fieldworkerShare_header_"+fieldWorkerId).trigger('click');
        }

        if($("#vue_fieldworkerShare_inputs_"+fieldWorkerId).length){
            $("#vue_fieldworkerShare_inputs_"+fieldWorkerId+" .text-blue" ).trigger("click")
        }else{
            setTimeout(function(){
                $("#vue_fieldworkerShare_inputs_"+fieldWorkerId+" .text-blue" ).trigger("click")
            } , 1000)

        }


        //   let contractors = this.contractors_view;
      //   var i;
      //   for(i=0; i < contractors.length; i++) {
      //       if(contractors[i].contractor_id == fieldWorkerId){
      //           contractors[i].is_edit = 0;
      //       }
      //   }
      //   //ha3ml update ll vue
      //   getFieldworkersEarnings(this.bookingId, this.itemType, this.itemId, this.mergedInvoiceId, this.bookingNums, this.viewLocation)
      //       .then((response) => {
      //           console.log(response)
      //
      //           this.loggedUser = response.data.loggedUser;
      //           this.loggedRoleNotAdmin = response.data.loggedRoleNotAdmin;
      //           this.loggedRoleFieldworker = response.data.loggedRoleFieldworker;
      //
      //           this.labelWorkersName = response.data.labelWorkersName;
      //           this.contractors_view = response.data.contractors_view;
      //           this.business_earnings = response.data.business_earnings;
      //           this.currency = response.data.currency;
      //           this.ModifyFieldworkerInvoiceNumberCheckCredential = response.data.ModifyFieldworkerInvoiceNumberCheckCredential;
      //           this.contractorsBookingSummaryWithSaveAsPaidCheckCredential = response.data.contractorsBookingSummaryWithSaveAsPaidCheckCredential;
      //
      //           this.editPopUpLabel = 'Edit ' + this.labelWorkersName + ' Invoice';
      //       })
      // let url;
      //
      // if (perService == 0) {
      //   url = `/booking/contractor_share/${this.bookingId}?fieldworker_id=${fieldWorkerId}`;
      // } else if (perService == 1) {
      //   url = `/booking/contractor_share/${this.bookingId}?per_service=${perService}&fieldworker_id=${fieldWorkerId}`
      // }
      //
      // popupi(`${this.labelWorkersName} Share`, url);
    },
      setNumericValue(number){
          // number = 151.2651235423;
          // number = '151,15.2651235423';
          // number = '151';
        if(number){
          number = number.toString().replace(',' , '');
            number = parseFloat(number).toFixed(2);
          //   alert(parseFloat(number).toFixed(2));
          //   let decimalNumber = (number.split(".").length > 1) ? number.split(".")[1]  : "00" ;
          // number = (number.split(".").length > 1) ? number.split(".")[0] : number;
          // let hasDecimal = (number.split(".").length == 0) ? 1 : 0;
                return humanRead(number , ',');
          // return humanRead(number , ',') + "." + decimalNumber;
        }else
          return 0
          // return number;

//           return parseFloat(humanRead( ((number)) , ',')).toFixed(2);
      },
      handleMouseHover(e){
          this.isDropdownVisible = true
          if (this.dropDownClicked < 1){
          const targetElement = e.target;
          targetElement.click();
          }
          this.dropDownClicked += 1

      },
      handleMouseLeave(){
          this.isDropdownVisible = false
      }
  }



}
</script>


<style>

@media (min-width: 1025px) and (max-width: 1440px){
    .field-worker-earnings-component .paid-amount {
        position: relative !important;
        left: 9px !important;;
        text-align: right !important;;
    }
}

.text-block{
    /*border: 1px solid #000;*/
    display: block;
}

.text-blue{
    text-decoration: blink;
    background-color: transparent;
    color: #428bca;
}
.save-btn{

    background-color: #03A9F4 !important;
    border-color: #03A9F4 !important;
    color: #FFF !important;
    -webkit-appearance: button !important;
    cursor: pointer !important;
    border: 1px solid transparent !important;
    padding: 6px 6px !important;
    border-radius: 4px !important;
}

.cancel-btn{

    background-color: #d9534f !important;
    border-color: #d43f3a !important;
    color: #FFF !important;
    -webkit-appearance: button !important;
    cursor: pointer !important;
    border: 1px solid transparent !important;
    padding: 6px 7px !important;
    border-radius: 4px !important;
}

.cancel-btn:hover{
    background-color: #c9302c !important;
    border-color: #ac2925 !important;
}

.text-input{
    background-color: #FFFFFF !important;
    border: 1px solid #e5e6e7 !important;
    border-radius: 1px !important;
    font-size: 14px !important;
    height: auto !important;
    padding: 5px !important;
}
.margin-top-10 {
  margin-top: 10px !important;
}
.m-top-6 {
  margin-top: 6px !important;
}
.field-worker-earnings-component .name-alignment {
  display: flex !important;
  padding-left: 15px !important;
  justify-content: flex-start !important;
}
.field-worker-earnings-component .align-self-center {
  align-self: center !important;
}
.field-worker-earnings-component .text-align-start {
  text-align: start;
}

.field-worker-earnings-component .gray-text {
  color: #2E4051;
}

.field-worker-earnings-component .font-size-14 {
  font-size: 14px;
}

.field-worker-earnings-component .bold-font {
  font-weight: bold;
}

.field-worker-earnings-component .span-font-size {
  font-size: 12px;
}

.field-worker-earnings-component .icon-padding {
  padding-right: 8px;
}

.field-worker-earnings-component .padding-15 {
  padding: 15px !important;
}

.field-worker-earnings-component .padding-top-10 {
  padding-top: 10px !important;
}

.field-worker-earnings-component .three-dots-alignment {
  position: relative;
  left: 51px;
  top: 4px;
}

.field-worker-earnings-component .paid-amount {
  position: relative;
  left: 75px;
}

.field-worker-earnings-component .font-size-strong {
  font-size: 1em !important;
}

.field-worker-earnings-component .fa-lg {
  vertical-align: -7%
}

.business-earnings-component .text-align-end {
  text-align: end;
}

.business-earnings-component .v-card {
  //background: #F5F5F6 !important;
  padding: 0px 25px 0px 25px;
}

/* vue classes */

.field-worker-earnings-component .v-expansion-panels {
  z-index: unset !important;
}

.field-worker-earnings-component .v-expansion-panels .v-expansion-panel {
  //background: #F5F5F6 !important;
}

.field-worker-earnings-component .v-list {
  //background: #F5F5F6 !important;
}

.field-worker-earnings-component .dropdown-menu {
  background: #fff !important;
}

.field-worker-earnings-component .v-list a {
  text-decoration: none;
}

.field-worker-earnings-component .v-expansion-panel--active .v-expansion-panel-content {
  padding: 0px 15px 0px 25px !important;
  font-size: 14px !important;
  width: 100%;
}

.field-worker-earnings-component .v-list-item__title strong {
  font-size: 1.3em;
}

.field-worker-earnings-component .v-expansion-panel-header {
  font-size: 14px !important;
}

.field-worker-earnings-component .v-expansion-panel-content > .v-expansion-panel-content__wrap {
  width: 100% !important;
  //background: #F5F5F6;
}

.field-worker-earnings-component .v-menu {
  position: relative !important;
  z-index: 9999999999999 !important;
  display: block !important;
}

.field-worker-earnings-component .v-list-item__title {
  font-size: 12px !important;
  line-height: 2.2 !important;
}

.field-worker-earnings-component .v-menu .menuable__content__active {
  top: 1093px !important;
  left: 318px !important;
}

button.v-btn.v-btn--icon.v-btn--round.theme--dark.v-size--default {
  color: rgba(0, 0, 0, .54);
  right: 10px;
}

.field-worker-earnings-component .v-expansion-panel-header .v-expansion-panel-header--active {
  //background: #F5F5F6;
}

.field-worker-earnings-component .v-expansion-panel-content {
  //background: #F5F5F6;
}

.field-worker-earnings-component .v-expansion-panel-content__wrap .v-list-item.theme--light {
  //background: #F5F5F6;
}

.field-worker-earnings-component .v-expansion-panel-header:before {
  background: #FFFFFF !important;
}

.field-worker-earnings-component .v-card {
  border: none !important;
  //background: #F5F5F6 !important;
}
.field-worker-earnings-component .v-card__text {
  border: 1px solid #EAECEE;
  border-radius: 12px;
  padding: 3px !important;
}

.icons-position {
  margin-left: 12px !important;
}
/*.icons-position a{*/
/*  position: relative;*/
/*  top: 4px;*/
/*  left: 6px;*/
/*}*/
/*.icons-position:hover {*/
/*  height: 30px;*/
/*  width: 30px;*/
/*  background-color: #bbb;*/
/*  border-radius: 50%;*/
/*  display: inline-block;*/
/*  position: relative;*/
/*}*/

.field-worker-earnings-component .form-control{
    background-color: #FFFFFF !important;
}

.popover {
    padding: 0px !important;
}

.mdi-chevron-down::before {
    font-size: 28px !important;
    font-weight: bold !important;
    color: #2E4051 !important;
}

.mdi-chevron-down::before {
    font-size: 28px !important;
    font-weight: bold !important;
    color: #2E4051 !important;

    //content: "\F0143";
    //color: rgb(46, 64, 81);
    //font-size: 31px;
    //font-weight: bold;
}
.invoice-popup-container .select-services-dropdown-title{
    font-weight: 700;
    font-size: 14px;
    color: #2e4051;
}
/*For Large Laptop*/
@media (min-width: 1025px) and (max-width: 1440px) {
  .field-worker-earnings-component .laptop-three-dots-display {
    display: flex !important;
    justify-content: flex-end;
  }

  .field-worker-earnings-component .paid-amount {
    position: relative;
    left: 40px;
  }

  .field-worker-earnings-component .name-alignment {
    padding-left: 30px !important;
  }
    .field-worker-earnings-component .laptop-position {
        margin-right: 17px;
    }
}

/*For Laptop*/
@media (min-width: 767px) and (max-width: 1024px) {
  .field-worker-earnings-component .laptop-three-dots-display {
    display: flex !important;
    justify-content: flex-end;
  }

  .field-worker-earnings-component .paid-amount {
    position: relative;
    left: 8px;
  }
  .field-worker-earnings-component .name-alignment {
    display: block !important;
    padding-left: 30px !important;
  }

  .field-worker-earnings-component .v-card__text {
    padding: 0px !important;
  }

  .field-worker-earnings-component .v-expansion-panel-header{
    padding: 16px 14px !important;
  }
  .field-worker-earnings-component .v-expansion-panel--active .v-expansion-panel-content{
    padding: unset !important;
  }
}


/* For Large & Medium Mobiles */
@media (min-width: 375px) and (max-width: 425px){
  .field-worker-earnings-component .name-alignment {
    display: block !important;
    padding-left: 30px !important;
  }
  .field-worker-earnings-component .paid-amount{
    left: 22px;
  }
  .field-worker-earnings-component .laptop-three-dots-display{
    position: relative;
    right: 22px;
  }
  .field-worker-earnings-component .v-expansion-panel-header{
    padding: 16px 12px !important;
  }
  .field-worker-earnings-component .v-expansion-panel--active .v-expansion-panel-content{
    padding: unset !important;
  }

}

/* For Small Mobiles */
@media (min-width: 280px) and (max-width: 320px){
  .field-worker-earnings-component .v-card__text {
    padding: 0px !important;
  }
  .field-worker-earnings-component .name-alignment {
    display: block !important;
    padding-left: 30px !important;
  }
  .field-worker-earnings-component .paid-amount{
    left: 4px;
  }


  .field-worker-earnings-component .laptop-three-dots-display{
    position: relative;
    right: 30px;
  }
  .field-worker-earnings-component .v-expansion-panel-header{
    padding: 16px 12px !important;
  }
  .field-worker-earnings-component .v-expansion-panel--active .v-expansion-panel-content{
    padding: unset !important;
  }

}
.mobile-view-transform{
    min-width: 290px;
}
@media only screen and (max-width: 768px) {
    .v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active{
        top: 819px!important;
    }
    .mobile-view-transform {
        transform: translateX(-50%);
    }
}

</style>

<style scoped src="vuetify/dist/vuetify.min.css"></style>
<style scoped lang="scss" src="@mdi/font/scss/materialdesignicons.scss"></style>